
import React, { useEffect, useState } from 'react';
import CampusHeader from '../../components/feature/CampusHeader';
import Footer from '../../components/feature/Footer';
import { auth, db } from '../../lib/firebase';
import { getUserProfile, updateUserProfile, subscribeAuth } from '../../services/auth';
import { NIGERIAN_UNIVERSITIES } from '../../data/nigerianUniversities';
import { getSellerListings, type Listing, updateListing, setAllTicketTiersSoldOut } from '../../services/listings';
import { uploadProfileImage } from '../../services/storage';
import { getWallet, subscribeToWalletTransactions, type WalletData, type WalletTransaction } from '../../services/wallet';
import { getSellerDailyViews, getSellerDailyProfileViews, getListingDailyViews } from '../../services/stats';
import { useNavigate, useLocation } from 'react-router-dom';
import { doc, getDoc, collection, getDocs } from 'firebase/firestore';
import CreateListingModal from '../../components/modals/CreateListingModal';
import BulkListingModal from '../../components/modals/BulkListingModal';
import ListingSuccessModal from '../../components/modals/ListingSuccessModal';
import { toUserMessage } from '../../utils/errors';
import ManageListingsModal from '../../components/modals/ManageListingsModal';

import { listSellerTicketLinks, updateTicketLink, listTicketPurchasesBySeller, createTicketLink, deleteTicketLink, type TicketLink } from '../../services/ticketLinks';
import CreateTicketModal from '../../components/modals/CreateTicketModal';
import { subscribeActiveMessagesForUser, dismissMessage, type AdminMessage } from '../../services/adminMessages';
import OnboardingTour from '../../components/OnboardingTour';

const SellerDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('overview');
  const [isVerified, setIsVerified] = useState(false);
  const [verificationStatus, setVerificationStatus] = useState<string>('pending');
  const [rejectionReason, setRejectionReason] = useState<string | null>(null);
  const [userName, setUserName] = useState('');
  const [email, setEmail] = useState<string | null>(null);
  const [university, setUniversity] = useState<string | null>(null);
  const [username, setUsername] = useState<string | null>(null);
  // Mandatory "complete your seller profile" gate (store name + school).
  const [showCompleteProfile, setShowCompleteProfile] = useState(false);
  const [cpUsername, setCpUsername] = useState('');
  const [cpUniversity, setCpUniversity] = useState('');
  const [cpSaving, setCpSaving] = useState(false);
  const [phone, setPhone] = useState<string | null>(null);
  const [studentIdUrl, setStudentIdUrl] = useState<string | null>(null);
  const [studentNumber, setStudentNumber] = useState<string | null>(null);
  const [photoURL, setPhotoURL] = useState<string | null>(null);
  const [bio, setBio] = useState<string | null>(null);
  const [plan, setPlan] = useState<'basic' | 'pro' | null>(null);
  const [savingProfile, setSavingProfile] = useState(false);

  const [activeListings, setActiveListings] = useState(0);
  const [listings, setListings] = useState<Listing[]>([]);
  const [updatingListingId, setUpdatingListingId] = useState<string | null>(null);

  const [wallet, setWallet] = useState<WalletData | null>(null);
  const [transactions, setTransactions] = useState<WalletTransaction[]>([]);
  const [profileViews, setProfileViews] = useState(0);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [createdListingId, setCreatedListingId] = useState<string | null>(null);
  const [dailyViewsSeries, setDailyViewsSeries] = useState<{ date: string; count: number }[]>([]);
  const [dailyProfileViewsSeries, setDailyProfileViewsSeries] = useState<{ date: string; count: number }[]>([]);
  const [focusedListingId, setFocusedListingId] = useState<string | null>(null);
  const [listingDailySeries, setListingDailySeries] = useState<{ date: string; count: number }[]>([]);
  const [manageOpen, setManageOpen] = useState(false);
  const [referralCount, setReferralCount] = useState(0);
  const [ticketLinks, setTicketLinks] = useState<TicketLink[]>([]);
  const [ticketBuyers, setTicketBuyers] = useState<any[]>([]);
  // Ticket Sales list controls
  const [ticketSort, setTicketSort] = useState<'recent' | 'oldest' | 'alpha'>('recent');
  const [ticketGroupByTier, setTicketGroupByTier] = useState(false);
  const [tlLoading, setTlLoading] = useState(false);

const [savingLinkId, setSavingLinkId] = useState<string | null>(null);
const [createModalType, setCreateModalType] = useState<'item' | 'house' | 'ticket'>('item');
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [showCreateChooser, setShowCreateChooser] = useState(false);
  const [showTicketModal, setShowTicketModal] = useState(false);
  const [editingTicket, setEditingTicket] = useState<TicketLink | null>(null);
  const [showRecentActivity, setShowRecentActivity] = useState(false);

  const refreshTicketLinks = async () => {
    const uid = auth.currentUser?.uid;
    if (!uid) return;
    try { setTicketLinks(await listSellerTicketLinks(uid)); } catch {}
  };

  const handleDeleteTicket = async (link: TicketLink) => {
    if (!link.id) return;
    if (!confirm(`Delete "${link.title}"? This removes the event and its link. Tickets already sold are unaffected.`)) return;
    try {
      await deleteTicketLink(link.id);
      setTicketLinks((prev) => prev.filter((l) => l.id !== link.id));
    } catch {
      alert('Could not delete. Please try again.');
    }
  };
  const [adminMsgs, setAdminMsgs] = useState<AdminMessage[]>([]);
  const [showOnboarding, setShowOnboarding] = useState(false);

  // Ticket link creation + share modals
  const [showCreateTicketLinkModal, setShowCreateTicketLinkModal] = useState(false);
  const [shareTicketLinkModalOpen, setShareTicketLinkModalOpen] = useState(false);
  const [createdTicketLinkId, setCreatedTicketLinkId] = useState<string | null>(null);
  const [tlFormTitle, setTlFormTitle] = useState('');
  const [tlFormPrice, setTlFormPrice] = useState('');
  const [tlFormMaxQty, setTlFormMaxQty] = useState('');
  const [tlFormDescription, setTlFormDescription] = useState('');
  const [tlSaving, setTlSaving] = useState(false);

  useEffect(() => {
    let walletUnsub: any;
    let adminUnsub: any;

    const fetchSellerData = async (uid: string) => {
      const profile = await getUserProfile(uid);
      if (profile) {
        setUserName(profile.fullName || '');
        setEmail(profile.email || null);
        setUniversity(profile.university || null);
        setUsername((profile as any).username || null);
        // Existing sellers must have a store name AND a school — gate until they do.
        if (!(profile as any).username || !profile.university) {
          setCpUsername((profile as any).username || '');
          setCpUniversity(profile.university || '');
          setShowCompleteProfile(true);
        }
        setPhone(profile.phone || null);
        setStudentIdUrl(profile.studentIdUrl || null);
        setStudentNumber(profile.studentNumber || null);
        setIsVerified(profile.isVerified || false);
        setVerificationStatus(profile.status || 'pending');
        setRejectionReason(profile.rejectionReason || null);
        setPhotoURL((profile as any).photoURL || null);
        setBio((profile as any).bio || null);
        setPlan((profile as any).plan || 'basic');

        try {
          const snap = await getDoc(doc(db, 'users', uid));
          if (snap.exists()) {
            const data = snap.data() as any;
            setProfileViews(typeof data.profileViews === 'number' ? data.profileViews : 0);
          }
        } catch (e) {
          setProfileViews(0);
        }

        if (profile.status === 'rejected' && profile.rejectionReason) {
          alert('Your seller account has been rejected. Please contact support.');
        }
      }

      // Tickets are managed in the separate Tickets section, not in Manage Listings.
      const sellerListings = (await getSellerListings(uid)).filter(l => l.type !== 'ticket');
      setListings(sellerListings);
      setActiveListings(sellerListings.length);

      const w = await getWallet(uid);
      setWallet(w);
      try {
        const sub = collection(doc(db, 'users', uid), 'referrals');
        const snap = await getDocs(sub);
        setReferralCount(snap.size);
      } catch {}

      walletUnsub = subscribeToWalletTransactions(uid, (txs) => {
        setTransactions(txs);
      });

      try {
        const series = await getSellerDailyViews(uid, 14);
        setDailyViewsSeries(series);
        const profileSeries = await getSellerDailyProfileViews(uid, 14);
        setDailyProfileViewsSeries(profileSeries);
      } catch {}

      // Ticket Links and Buyers
      try {
        setTlLoading(true);
        const [links, buyers] = await Promise.all([
          listSellerTicketLinks(uid),
          listTicketPurchasesBySeller(uid)
        ]);
        setTicketLinks(links);
        setTicketBuyers(buyers);
      } catch {}
      finally {
        setTlLoading(false);
      }

      // Admin messages subscription
      try {
        adminUnsub = subscribeActiveMessagesForUser(uid, 'seller', (msgs) => setAdminMsgs(msgs));
        // First-time seller tour
        const tourKey = `seller_onboarding_shown_${uid}`;
        if (!localStorage.getItem(tourKey)) {
          setShowOnboarding(true);
          localStorage.setItem(tourKey, '1');
        }
      } catch {}
    };

    const unsubAuth = subscribeAuth(async (user) => {
      if (user?.uid) {
        await fetchSellerData(user.uid);
      } else {
        setUserName('');
        setEmail(null);
        setUniversity(null);
        setPhone(null);
        setStudentIdUrl(null);
        setStudentNumber(null);
        setIsVerified(false);
        setVerificationStatus('pending');
        setRejectionReason(null);
        setPhotoURL(null);
        setBio(null);
        setPlan('basic');
        setListings([]);
        setActiveListings(0);
        setWallet(null);
        setTransactions([]);
        setDailyViewsSeries([]);
        setReferralCount(0);
      }
    });

return () => {
      unsubAuth && unsubAuth();
      walletUnsub && typeof walletUnsub === 'function' && walletUnsub();
      adminUnsub && typeof adminUnsub === 'function' && adminUnsub();
    };
  }, []);

  // Sync tab and focused listing from query params
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab');
    const listingId = params.get('listingId');
    if (tab === 'analytics') setActiveTab('analytics');
    if (listingId) setFocusedListingId(listingId);
    // Open create modal via URL params
    const action = params.get('action');
    const typeParam = params.get('type');
    if (action === 'create') {
      const nextType = (typeParam === 'house' || typeParam === 'ticket') ? typeParam : 'item';
      setCreateModalType(nextType as 'item' | 'house' | 'ticket');
      setShowCreateModal(true);
    }
  }, [location.search, verificationStatus, isVerified]);

  // Fetch per-listing daily views when focusedListingId changes
  useEffect(() => {
    const run = async () => {
      if (!focusedListingId) { setListingDailySeries([]); return; }
      try {
        const series = await getListingDailyViews(focusedListingId, 14);
        setListingDailySeries(series);
      } catch {
        setListingDailySeries([]);
      }
    };
    if (activeTab === 'analytics') {
      run();
    }
  }, [focusedListingId, activeTab]);

  const handleUpgrade = () => {
    navigate('/pricing');
  };

  const handlePostNewItem = () => {
    // Ask single vs bulk first.
    setShowCreateChooser(true);
  };

  const handleCompleteProfile = async () => {
    const uid = auth.currentUser?.uid;
    if (!uid) return;
    if (cpUsername.trim().length < 2) { alert('Enter a store/vendor name (at least 2 characters).'); return; }
    if (cpUniversity.trim().length < 2) { alert('Please select your school.'); return; }
    setCpSaving(true);
    try {
      await updateUserProfile(uid, { username: cpUsername.trim(), university: cpUniversity.trim() });
      setUsername(cpUsername.trim());
      setUniversity(cpUniversity.trim());
      setShowCompleteProfile(false);
    } catch {
      alert('Could not save. Please try again.');
    } finally {
      setCpSaving(false);
    }
  };

  const handleSaveProfile = async () => {
    if (!auth.currentUser) return;
    setSavingProfile(true);
    try {
      await updateUserProfile(auth.currentUser.uid, {
        fullName: userName || null,
        phone: phone || null,
        university: university || null,
        photoURL: photoURL || null,
        bio: bio || null,
      });
    } catch (e) {
      console.error('Failed to update profile', e);
      alert(toUserMessage(e));
    } finally {
      setSavingProfile(false);
    }
  };

  const handlePhotoChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file || !auth.currentUser) return;
    try {
      const url = await uploadProfileImage(file, auth.currentUser.uid);
      setPhotoURL(url);
      // Persist immediately so users don't have to click Save
      await updateUserProfile(auth.currentUser.uid, { photoURL: url });
    } catch (err) {
      alert(toUserMessage(err));
    }
  };

  const handleUpdateLink = async (linkId: string, updates: Partial<TicketLink>) => {
    setSavingLinkId(linkId);
    try {
      await updateTicketLink(linkId, updates);
      if (auth.currentUser) {
        const links = await listSellerTicketLinks(auth.currentUser.uid);
        setTicketLinks(links);
      }
    } catch (e) {
      alert('Failed to update link');
    } finally {
      setSavingLinkId(null);
    }
  };

  const handleLimitRemaining = async (link: TicketLink, remainingStr: string) => {
    const r = Number(remainingStr);
    if (isNaN(r) || r < 0) {
      alert('Enter a valid remaining count');
      return;
    }
    const sold = Number(link.soldCount || 0);
    await handleUpdateLink(link.id!, { maxQuantity: sold + r });
  };

  const handleMarkSoldOutNow = async (link: TicketLink) => {
    const sold = Number(link.soldCount || 0);
    await handleUpdateLink(link.id!, { maxQuantity: sold, status: 'inactive' });
  };

  const handleCopyPurchaseUrl = async (linkId: string) => {
    // Share via the OG endpoint so link previews show the flyer + title + price.
    const url = `${window.location.origin}/api/ticket-share?id=${linkId}`;
    try {
      await navigator.clipboard.writeText(url);
      alert('Event link copied — paste it to share. Previews will show your flyer.');
    } catch {}
  };

  // Create a new ticket link and open share modal
  const handleCreateTicketLink = async () => {
    if (!auth.currentUser) { alert('Please sign in'); return; }
    const sellerId = auth.currentUser.uid;
    const title = tlFormTitle.trim();
    const priceNaira = Number(tlFormPrice);
    const maxQtyNum = tlFormMaxQty ? Number(tlFormMaxQty) : undefined;
    if (!title) { alert('Enter a title'); return; }
    if (isNaN(priceNaira) || priceNaira <= 0) { alert('Enter a valid price'); return; }
    setTlSaving(true);
    try {
      const link = await createTicketLink({
        sellerId,
        title,
        price: priceNaira,
        maxQuantity: typeof maxQtyNum === 'number' && !isNaN(maxQtyNum) && maxQtyNum > 0 ? maxQtyNum : undefined,
        description: tlFormDescription.trim() || undefined
      });
      setCreatedTicketLinkId(link.id || null);
      setShowCreateTicketLinkModal(false);
      setShareTicketLinkModalOpen(true);
      try {
        setTlLoading(true);
        const [links, buyers] = await Promise.all([
          listSellerTicketLinks(sellerId),
          listTicketPurchasesBySeller(sellerId)
        ]);
        setTicketLinks(links);
        setTicketBuyers(buyers);
      } finally {
        setTlLoading(false);
      }
      setTlFormTitle('');
      setTlFormPrice('');
      setTlFormMaxQty('');
      setTlFormDescription('');
    } catch (e: any) {
      alert(toUserMessage(e) || 'Failed to create ticket link');
    } finally {
      setTlSaving(false);
    }
  };

  const purchaseUrlFromId = (id: string) => {
    const origin = (typeof window !== 'undefined' && window.location && window.location.origin) ? window.location.origin : '';
    return `${origin}/api/ticket-share?id=${id}`;
  };

  return (
    <div className="min-h-screen bg-white">
      <CampusHeader userName={userName} />

      <main className="w-full py-8 px-6">
        {showOnboarding && (
          <OnboardingTour role="seller" onClose={() => setShowOnboarding(false)} />
        )}
        <h1 className="text-xl md:text-3xl font-bold text-gray-900 mb-2">Welcome, {userName?.split(' ')[0] || 'Seller'}!</h1>
        <p className="text-gray-600 mb-8">
          Manage your listings, earnings, and analytics.
        </p>
        {adminMsgs.length > 0 && adminMsgs.map((m) => (
          <div key={m.id} className="bg-indigo-50 border border-indigo-200 rounded-lg p-4 mb-4 flex items-start justify-between">
            <div className="flex items-start gap-3">
              <i className="ri-megaphone-line text-indigo-600 text-xl"></i>
              <p className="text-sm text-indigo-800">{m.text}</p>
            </div>
            <button
              className="text-xs px-2 py-1 border rounded hover:bg-gray-50"
              onClick={async () => {
                if (!auth.currentUser || !m.id) return;
                try {
                  await dismissMessage(m.id, auth.currentUser.uid);
                  setAdminMsgs(prev => prev.filter(x => x.id !== m.id));
                } catch {}
              }}
            >
              Dismiss
            </button>
          </div>
        ))}

        {plan !== 'pro' && (
          <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-4 mb-6">
            <div className="flex items-center justify-between gap-3">
              <div className="flex items-center gap-3">
                <i className="ri-gift-2-line text-emerald-600 text-xl"></i>
                <div>
                  <h3 className="text-sm font-semibold text-emerald-800">You're on the Free plan — everything unlocked</h3>
                  <p className="text-xs text-emerald-700">All features are free right now. Paid Pro plans (lower fees, priority placement, analytics) arrive sometime next year.</p>
                </div>
              </div>
              <span className="flex-shrink-0 rounded-full bg-emerald-600 px-3 py-1 text-xs font-semibold text-white">Free</span>
            </div>
          </div>
        )}

        <div className="grid grid-cols-1 gap-8">
          {/* Main Content */}
          <div>
            {/* Verification Status */}
            {verificationStatus === 'pending' && (
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <svg className="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <h3 className="text-sm font-medium text-yellow-800">Verification Pending</h3>
                    <div className="mt-2 text-sm text-yellow-700">
                      <p>Your seller account is under review. You'll be able to post items once approved.</p>
                    </div>
                  </div>
                </div>

                <div className="mt-6 bg-white border border-gray-200 rounded-lg p-6">
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="font-semibold text-gray-900">Listing Views (Select Product)</h3>
                    <select
                      className="px-3 py-2 border border-gray-300 rounded-lg bg-white text-sm"
                      value={focusedListingId || ''}
                      onChange={(e) => setFocusedListingId(e.target.value || null)}
                    >
                      <option value="">Select listing</option>
                      {listings.map((l) => (
                        <option key={l.id} value={l.id!}>{l.title}</option>
                      ))}
                    </select>
                  </div>
                  <div className="h-32 bg-gray-100 rounded">
                    {(() => {
                      const lastNDays = (n: number) => {
                        const days: string[] = [];
                        const today = new Date();
                        for (let i = n - 1; i >= 0; i--) {
                          const d = new Date(today);
                          d.setDate(today.getDate() - i);
                          const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
                          days.push(key);
                        }
                        return days;
                      };
                      const keys = lastNDays(14);
                      const series = listingDailySeries.length > 0
                        ? keys.map(k => ({ key: k, value: (listingDailySeries.find(s => s.date === k)?.count ?? 0) }))
                        : keys.map(k => ({ key: k, value: 0 }));
                      const maxVal = Math.max(1, ...series.map(p => p.value));
                      const chartWidth = 500;
                      const chartHeight = 120;
                      const padding = 24;
                      const points = series.map((p, i) => {
                        const x = padding + (i * (chartWidth - padding * 2)) / (series.length - 1);
                        const y = padding + (1 - p.value / maxVal) * (chartHeight - padding * 2);
                        return `${x},${y}`;
                      }).join(' ');
                      return (
                        <svg viewBox={`0 0 ${chartWidth} ${chartHeight}`} className="w-full h-full">
                          <polyline fill="none" stroke="rgb(147 51 234)" strokeWidth="2" points={points} />
                          <line x1={padding} y1={chartHeight - padding} x2={chartWidth - padding} y2={chartHeight - padding} stroke="#9ca3af" strokeDasharray="3 3" />
                        </svg>
                      );
                    })()}
                  </div>
                  <div className="mt-2 text-sm text-gray-600">
                    Total views: {listingDailySeries.reduce((sum, p) => sum + (p.count || 0), 0)}
                  </div>
                </div>
              </div>
            )}

            {/* Missing Docs Warning */}
            {(!studentIdUrl || !studentNumber || !university) && (
              <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 mb-6">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                  <div className="flex items-center gap-3">
                    <svg className="h-5 w-5 text-orange-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.214 2.98-1.743 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 10-2 0 1 1 0 002 0zm-1-2a1 1 0 01-1-1V7a1 1 0 112 0v3a1 1 0 01-1 1z" clipRule="evenodd" />
                    </svg>
                    <div>
                      <h3 className="text-sm font-medium text-orange-800">Missing Verification Documents</h3>
                      <p className="text-sm text-orange-700">Please submit your university and student ID to complete verification.</p>
                    </div>
                  </div>
                  <button
                    onClick={() => navigate('/sell?resume=docs')}
                    className="w-full md:w-auto md:self-center px-3 py-2 bg-orange-600 text-white rounded hover:bg-orange-700"
                  >
                    Submit Documents
                  </button>
                </div>
              </div>
            )}
            
            {verificationStatus === 'rejected' && rejectionReason && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <svg className="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <h3 className="text-sm font-medium text-red-800">Account Rejected</h3>
                    <div className="mt-2 text-sm text-red-700">
                      <p><strong>Reason:</strong> {rejectionReason}</p>
                      <p className="mt-1">Please contact support if you believe this is an error.</p>
                    </div>
                  </div>
                </div>
              </div>
            )}
            
            {verificationStatus === 'approved' && (
              <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <svg className="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <h3 className="text-sm font-medium text-green-800">Account Verified</h3>
                    <div className="mt-2 text-sm text-green-700">
                      <p>Your seller account has been approved! You can now post items for sale.</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Seller Stats */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6 mb-6 md:mb-8">
              <div className="bg-white rounded-xl shadow-sm p-4 md:p-6 flex items-center justify-between">
                <div>
                  <div className="text-sm font-medium text-gray-500">Active Listings</div>
                  <div className="text-xl md:text-3xl font-bold text-gray-900">{activeListings}</div>
                </div>
                <div className="p-3 rounded-full bg-blue-100 text-blue-600">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 md:h-8 md:w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M12 15h.01" />
                  </svg>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-sm p-4 md:p-6 flex items-center justify-between">
                <div>
                  <div className="text-sm font-medium text-gray-500">Total Earnings</div>
                  <div className="text-xl md:text-3xl font-bold text-gray-900">₦{(wallet?.totalEarnings ?? 0).toFixed(2)}</div>
                </div>
                <div className="p-3 rounded-full bg-green-100 text-green-600">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 md:h-8 md:w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-sm p-4 md:p-6 flex items-center justify-between">
                <div>
                  <div className="text-sm font-medium text-gray-500">Profile Views</div>
                  <div className="text-xl md:text-3xl font-bold text-gray-900">{profileViews}</div>
                </div>
                <div className="p-3 rounded-full bg-purple-100 text-purple-600">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 md:h-8 md:w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-sm p-4 md:p-6 flex items-center justify-between cursor-pointer hover:shadow-lg transition-shadow" onClick={() => navigate('/referrals')}>
                <div>
                  <div className="text-sm font-medium text-gray-500">Referrals</div>
                  <div className="text-xl md:text-3xl font-bold text-gray-900">{referralCount}</div>
                </div>
                <div className="p-3 rounded-full bg-pink-100 text-pink-600">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 md:h-8 md:w-8" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 12c2.761 0 5-2.239 5-5S14.761 2 12 2 7 4.239 7 7s2.239 5 5 5zm0 2c-3.866 0-7 3.134-7 7h14c0-3.866-3.134-7-7-7z"/>
                  </svg>
                </div>
              </div>
            </div>

            {/* Quick Actions */}
            <div className="mb-8">
              <h2 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 md:mb-4">Quick Actions</h2>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2.5 md:gap-4">
                <div className="border border-gray-200 rounded-xl p-3 md:p-4 text-center hover:shadow-lg transition-shadow cursor-pointer"
                  onClick={handlePostNewItem}>
                  <div className="p-3 rounded-full bg-blue-100 text-blue-600 mx-auto mb-2 md:mb-3 w-9 h-9 md:w-11 md:h-11 flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 md:h-6 md:w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                  </div>
                  <div className="font-semibold text-gray-800 text-sm md:text-base">Create Listing</div>
                  <p className="text-xs md:text-sm text-gray-500">Single or bulk upload</p>
                </div>

                <div className="border border-gray-200 rounded-xl p-3 md:p-4 text-center hover:shadow-lg transition-shadow cursor-pointer"
                  onClick={() => setShowTicketModal(true)}>
                  <div className="p-3 rounded-full bg-purple-100 text-purple-600 mx-auto mb-2 md:mb-3 w-9 h-9 md:w-11 md:h-11 flex items-center justify-center">
                    <i className="ri-ticket-2-line text-xl md:text-2xl"></i>
                  </div>
                  <div className="font-semibold text-gray-800 text-sm md:text-base">Sell Tickets</div>
                  <p className="text-xs md:text-sm text-gray-500">Create an event &amp; get a link</p>
                </div>

                <div className="relative border border-gray-200 rounded-xl p-3 md:p-4 text-center opacity-70 cursor-not-allowed">
                  <span className="absolute top-2 right-2 rounded-full bg-orange-100 px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wide text-orange-600">Soon</span>
                  <div className="p-3 rounded-full bg-amber-100 text-amber-600 mx-auto mb-2 md:mb-3 w-9 h-9 md:w-11 md:h-11 flex items-center justify-center">
                    <i className="ri-home-4-line text-xl md:text-2xl"></i>
                  </div>
                  <div className="font-semibold text-gray-800 text-sm md:text-base">Hostel Listing</div>
                  <p className="text-xs md:text-sm text-gray-500">Coming soon</p>
                </div>

                <div className="border border-gray-200 rounded-xl p-3 md:p-4 text-center hover:shadow-lg transition-shadow cursor-pointer"
                  onClick={() => navigate('/wallet')}>
                  <div className="p-3 rounded-full bg-green-100 text-green-600 mx-auto mb-2 md:mb-3 w-9 h-9 md:w-11 md:h-11 flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 md:h-6 md:w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                  </div>
                  <div className="font-semibold text-gray-800 text-sm md:text-base">Wallet</div>
                  <p className="text-xs md:text-sm text-gray-500">Manage your earnings</p>
                </div>

                <div className="border border-gray-200 rounded-xl p-3 md:p-4 text-center hover:shadow-lg transition-shadow cursor-pointer"
                  onClick={() => setActiveTab('analytics')}>
                  <div className="p-3 rounded-full bg-purple-100 text-purple-600 mx-auto mb-2 md:mb-3 w-9 h-9 md:w-11 md:h-11 flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 md:h-6 md:w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div className="font-semibold text-gray-800 text-sm md:text-base">Analytics</div>
                  <p className="text-xs md:text-sm text-gray-500">Track performance</p>
                </div>
                
                {/* Manage Listings Quick Action */}
                <div className="border border-gray-200 rounded-xl p-3 md:p-4 text-center hover:shadow-lg transition-shadow cursor-pointer"
                  onClick={() => setManageOpen(true)}>
                  <div className="p-3 rounded-full bg-gray-100 text-gray-800 mx-auto mb-2 md:mb-3 w-9 h-9 md:w-11 md:h-11 flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 md:h-6 md:w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 3a.75.75 0 00-.75.75v1.5a.75.75 0 00.75.75h4.5a.75.75 0 00.75-.75v-1.5A.75.75 0 0014.25 3h-4.5zM5.58 6.75h12.84c.72 0 1.3.58 1.3 1.3v9.9a2.55 2.55 0 01-2.55 2.55H6.83A2.55 2.55 0 014.28 17.95v-9.9c0-.72.58-1.3 1.3-1.3zm3.42 3a.75.75 0 000 1.5h5.5a.75.75 0 000-1.5h-5.5z" />
                    </svg>
                  </div>
                  <div className="font-semibold text-gray-800 text-sm md:text-base">Manage Listings</div>
                  <p className="text-xs md:text-sm text-gray-500">Edit, delete, mark sold out</p>
                </div>
              </div>
            </div>

            {/* Profile Editor */}
            <div className="bg-white rounded-lg shadow p-6 mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">Seller Profile</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div>
                  <div className="w-32 h-32 rounded-full overflow-hidden bg-gray-100 border border-gray-200">
                    {photoURL ? (
                      <img src={photoURL} alt="Profile" className="w-full h-full object-cover" />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-gray-500">
                        <i className="ri-user-line text-5xl"></i>
                      </div>
                    )}
                  </div>
                  <label className="mt-3 inline-flex items-center gap-2 px-3 py-2 bg-gray-100 text-gray-700 rounded cursor-pointer hover:bg-gray-200">
                    <i className="ri-upload-2-line"></i>
                    <span className="text-sm">Upload photo</span>
                    <input type="file" accept="image/*" className="hidden" onChange={handlePhotoChange} />
                  </label>
                </div>
                <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">Full name</label>
                    <input className="w-full border border-gray-300 rounded px-3 py-2" value={userName || ''} onChange={(e) => setUserName(e.target.value)} />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">University</label>
                    <input className="w-full border border-gray-300 rounded px-3 py-2" value={university || ''} onChange={(e) => setUniversity(e.target.value)} />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">Phone</label>
                    <input className="w-full border border-gray-300 rounded px-3 py-2" value={phone || ''} onChange={(e) => setPhone(e.target.value)} />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">Student number</label>
                    <input className="w-full border border-gray-300 rounded px-3 py-2" value={studentNumber || ''} onChange={(e) => setStudentNumber(e.target.value)} />
                  </div>
                  <div className="md:col-span-2">
                    <label className="block text-sm text-gray-600 mb-1">Bio</label>
                    <textarea className="w-full border border-gray-300 rounded px-3 py-2" rows={3} value={bio || ''} onChange={(e) => setBio(e.target.value)} />
                  </div>
                </div>
              </div>
              <div className="mt-4">
                <button onClick={handleSaveProfile} disabled={savingProfile} className="px-4 py-2 bg-teal-600 text-white rounded hover:bg-teal-700 disabled:opacity-60">
                  {savingProfile ? 'Saving...' : 'Save profile'}
                </button>
              </div>
            </div>

            {/* Dashboard Overview */}
            {activeTab === 'overview' && (
              <div>
                <h2 className="text-xl font-semibold text-gray-900 mb-6">Dashboard Overview</h2>

                {/* Recent Activity (collapsed by default) */}
                <div className="bg-gray-50 rounded-lg">
                  <button
                    type="button"
                    onClick={() => setShowRecentActivity((v) => !v)}
                    className="flex w-full items-center justify-between p-6 text-left"
                  >
                    <h3 className="font-semibold text-gray-900">Recent Activity {transactions.length > 0 && <span className="ml-1 text-sm font-normal text-gray-400">({transactions.length})</span>}</h3>
                    <i className={`ri-arrow-down-s-line text-xl text-gray-500 transition-transform ${showRecentActivity ? 'rotate-180' : ''}`}></i>
                  </button>
                  {showRecentActivity && (
                    <div className="px-6 pb-6">
                      {transactions.length === 0 ? (
                        <p className="text-gray-500">No recent activity yet.</p>
                      ) : (
                        <div className="space-y-3">
                          {transactions.slice(0, 5).map((tx) => (
                            <div key={tx.id} className="flex items-center justify-between">
                              <div className="flex items-center space-x-3">
                                <div className={`w-2 h-2 rounded-full ${tx.type === 'credit' ? 'bg-green-500' : tx.type === 'debit' ? 'bg-red-500' : 'bg-blue-500'}`}></div>
                                <span className="text-gray-700">{tx.description}</span>
                              </div>
                              <div className="text-gray-500 text-sm">₦{tx.amount.toLocaleString()}</div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* Ticket Links */}
                <div className="mt-8 bg-white border border-gray-200 rounded-lg p-6">
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
                    <div>
                      <h3 className="font-semibold text-gray-900">Ticket Links</h3>
                      <p className="text-xs text-gray-500">Create events via <span className="font-medium">Sell Tickets</span>. Share &amp; track them here.</p>
                    </div>
                    <div className="flex gap-2">
                      <button
                        className="px-3 py-2 border rounded hover:bg-gray-50"
                        onClick={async () => {
                          if (!auth.currentUser) return;
                          try {
                            setTlLoading(true);
                            const [links, buyers] = await Promise.all([
                              listSellerTicketLinks(auth.currentUser.uid),
                              listTicketPurchasesBySeller(auth.currentUser.uid)
                            ]);
                            setTicketLinks(links);
                            setTicketBuyers(buyers);
                          } finally {
                            setTlLoading(false);
                          }
                        }}
                      >
                        Refresh
                      </button>
                    </div>
                  </div>

                  <div className="mb-4 flex items-start gap-2 rounded-lg bg-teal-50 px-3 py-2.5 text-sm text-teal-800 ring-1 ring-teal-100">
                    <i className="ri-information-line mt-0.5 flex-shrink-0"></i>
                    <span>Campus Market keeps <strong>5%</strong> of each ticket sale. The remaining <strong>95%</strong> is credited to your wallet automatically as tickets sell — withdraw it anytime from your Wallet.</span>
                  </div>

                  {tlLoading ? (
                    <div className="text-gray-500">Loading...</div>
                  ) : ticketLinks.length === 0 ? (
                    <div className="text-gray-500">No ticket links yet.</div>
                  ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                      {ticketLinks.map((link) => {
                        // Count from actual recorded purchases (authoritative) — the link's
                        // soldCount can lag if its follow-up update ever failed.
                        const linkPurchases = ticketBuyers.filter((p) => p.linkId === link.id);
                        const buyersCount = linkPurchases.length;
                        const ticketsFromPurchases = linkPurchases.reduce((s, p) => s + (Number(p.quantity) || 1), 0);
                        const sold = Math.max(Number(link.soldCount || 0), ticketsFromPurchases);
                        const maxQ = Number(link.maxQuantity || 0);
                        const remaining = maxQ > 0 ? Math.max(0, maxQ - sold) : Infinity;
                        const isSoldOut = maxQ > 0 && remaining === 0;
                        return (
                          <div key={link.id} className="border border-gray-200 rounded-lg p-4">
                            <div className="flex items-center justify-between mb-2">
                              <h4 className="font-medium text-gray-900 truncate">{link.title || 'Untitled'}</h4>
                              <span className={`px-2 py-1 rounded-full text-xs ${isSoldOut ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}>{isSoldOut ? 'sold out' : 'available'}</span>
                            </div>
                            <div className="mb-3 grid grid-cols-2 gap-2">
                              <div className="rounded-lg bg-teal-50 px-3 py-2 ring-1 ring-teal-100">
                                <div className="text-lg font-bold text-teal-700">{buyersCount}</div>
                                <div className="text-[11px] font-medium uppercase tracking-wide text-teal-600">{buyersCount === 1 ? 'buyer' : 'buyers'}</div>
                              </div>
                              <div className="rounded-lg bg-gray-50 px-3 py-2 ring-1 ring-gray-100">
                                <div className="text-lg font-bold text-gray-900">{sold}{maxQ > 0 ? ` / ${maxQ}` : ''}</div>
                                <div className="text-[11px] font-medium uppercase tracking-wide text-gray-500">tickets sold</div>
                              </div>
                            </div>
                            {Array.isArray(link.tiers) && link.tiers.length > 0 && (
                              <div className="mb-3 space-y-2">
                                <div className="text-[11px] font-semibold uppercase tracking-wide text-gray-500">Ticket types</div>
                                {link.tiers.map((t, ti) => {
                                  const nm = (t.name || '').trim();
                                  const fromPurchases = linkPurchases
                                    .filter((p) => String(p.tierName || '').trim().toLowerCase() === nm.toLowerCase())
                                    .reduce((s, p) => s + (Number(p.quantity) || 1), 0);
                                  const tierSold = Math.max(Number(t.soldCount || 0), fromPurchases);
                                  const cap = typeof t.quantity === 'number' ? t.quantity : null;
                                  return (
                                    <div key={`${nm}-${ti}`} className="rounded-lg border border-gray-200 bg-gray-50/60 p-2.5">
                                      <div className="flex items-center justify-between gap-2">
                                        <div className="flex items-center gap-2 min-w-0">
                                          <span className="font-medium text-gray-900 truncate">{nm || 'Untitled'}</span>
                                          {(t as any).codePrefix && (
                                            <span className="rounded bg-purple-100 px-1.5 py-0.5 font-mono text-[10px] font-semibold text-purple-700">{(t as any).codePrefix}</span>
                                          )}
                                        </div>
                                        <span className="flex-shrink-0 text-sm font-bold text-teal-700">₦{Number(t.price || 0).toLocaleString('en-NG')}</span>
                                      </div>
                                      {t.perks && <div className="mt-1 text-xs text-gray-500 whitespace-pre-wrap">{t.perks}</div>}
                                      <div className="mt-1 text-[11px] font-medium text-gray-500">
                                        Sold: <span className="text-gray-900">{tierSold}{cap != null ? ` / ${cap}` : ''}</span>
                                        {cap != null && <span className="text-gray-400"> · {Math.max(0, cap - tierSold)} left</span>}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                            <div className="space-y-3">
                              <p className="text-xs text-gray-400">To change price, tiers, date or flyer, use <span className="font-medium text-purple-600">Edit</span> below.</p>
                              <div className="flex items-center gap-2">
                                <input
                                  type="number"
                                  className="flex-1 px-2 py-1 border rounded"
                                  defaultValue={Number.isFinite(remaining) ? remaining : ''}
                                  onChange={(e) => (link as any)._nextRemaining = e.target.value}
                                  placeholder="Remaining"
                                />
                                <button
                                  className="px-3 py-1 border rounded text-sm hover:bg-gray-50"
                                  disabled={savingLinkId === link.id}
                                  onClick={() => handleLimitRemaining(link, (link as any)._nextRemaining)}
                                >
                                  Limit Remaining
                                </button>
                              </div>
                              <div className="flex flex-wrap gap-2">
                                <button
                                  className="flex-1 px-3 py-2 border rounded hover:bg-gray-50"
                                  onClick={() => handleCopyPurchaseUrl(link.id!)}
                                >
                                  Copy Event Link
                                </button>
                                <button
                                  className="flex-1 px-3 py-2 border border-purple-300 text-purple-700 rounded hover:bg-purple-50"
                                  onClick={() => setEditingTicket(link)}
                                >
                                  <i className="ri-edit-line mr-1"></i>Edit
                                </button>
                                <button
                                  className="px-3 py-2 border border-orange-300 text-orange-700 rounded hover:bg-orange-50"
                                  disabled={savingLinkId === link.id}
                                  onClick={() => handleMarkSoldOutNow(link)}
                                  title="Mark sold out"
                                >
                                  <i className="ri-stop-circle-line"></i>
                                </button>
                                <button
                                  className="px-3 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                                  onClick={() => handleDeleteTicket(link)}
                                  title="Delete this event"
                                >
                                  <i className="ri-delete-bin-line"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>

                {/* Ticket Sales */}
                 {ticketBuyers.length > 0 && (
                   <div className="bg-white rounded-lg shadow p-6">
                     {(() => {
                       const naira = (n: number) => `₦${Number(n || 0).toLocaleString('en-NG')}`;
                       const totalTickets = ticketBuyers.reduce((s, p) => s + (Number(p.quantity) || 1), 0);
                       const earnings = ticketBuyers.reduce((s, p) => s + (Number(p.sellerAmount) || 0), 0);
                       const tsMs = (p: any) => (p.createdAt?.toDate ? p.createdAt.toDate().getTime() : (p.createdAt?.seconds ? p.createdAt.seconds * 1000 : 0));
                       // Apply the chosen sort order.
                       const sortBuyers = (arr: any[]) => {
                         const copy = [...arr];
                         if (ticketSort === 'alpha') copy.sort((a, b) => String(a.buyerName || '').localeCompare(String(b.buyerName || '')));
                         else if (ticketSort === 'oldest') copy.sort((a, b) => tsMs(a) - tsMs(b));
                         else copy.sort((a, b) => tsMs(b) - tsMs(a));
                         return copy;
                       };
                       const sortedBuyers = sortBuyers(ticketBuyers);
                       // Group into { tierName -> rows } when grouping is on, else a single "All" group.
                       const groups: { label: string; rows: any[] }[] = ticketGroupByTier
                         ? Object.entries(sortedBuyers.reduce((m: Record<string, any[]>, p) => {
                             const k = p.tierName || 'General';
                             (m[k] = m[k] || []).push(p);
                             return m;
                           }, {})).map(([label, rows]) => ({ label, rows }))
                         : [{ label: '', rows: sortedBuyers }];

                       const printSales = () => {
                         const sections = groups.map((g) => {
                           const rows = g.rows.map((p) => {
                             const link = ticketLinks.find(l => l.id === p.linkId);
                             const date = p.createdAt?.toDate ? p.createdAt.toDate().toLocaleString() : '';
                             const codes = Array.isArray(p.codes) ? p.codes.join(', ') : (p.code || '');
                             return `<tr><td>${link?.title || p.linkId || ''}</td><td>${p.buyerName || p.buyerId || ''}</td><td>${p.buyerEmail || ''}</td><td>${p.buyerPhone || ''}</td><td>${p.tierName || '-'}</td><td style="text-align:center">${p.quantity || 1}</td><td>${naira(p.totalAmount || 0)}</td><td style="font-family:monospace;font-size:11px">${codes}</td><td>${date}</td></tr>`;
                           }).join('');
                           const tierTickets = g.rows.reduce((s, p) => s + (Number(p.quantity) || 1), 0);
                           const heading = g.label ? `<h2 style="font-size:15px;margin:22px 0 4px">${g.label} — ${g.rows.length} orders · ${tierTickets} tickets</h2>` : '';
                           return `${heading}<table><thead><tr><th>Event</th><th>Buyer</th><th>Email</th><th>Phone</th><th>Tier</th><th>Qty</th><th>Amount</th><th>Code(s)</th><th>Date</th></tr></thead><tbody>${rows}</tbody></table>`;
                         }).join('');
                         const html = `<html><head><title>Ticket Sales</title><style>body{font-family:Arial,sans-serif;padding:24px;color:#0f172a}h1{font-size:18px;margin:0}h2{color:#0f766e}p{color:#475569}table{width:100%;border-collapse:collapse;margin-top:12px;font-size:13px;page-break-inside:auto}th,td{border:1px solid #e2e8f0;padding:6px 8px;text-align:left}th{background:#f1f5f9}</style></head><body><h1>Ticket Sales — Campus Market</h1><p>${ticketBuyers.length} orders · ${totalTickets} tickets · Your earnings: ${naira(earnings)} · Sorted by ${ticketSort === 'alpha' ? 'buyer name' : ticketSort === 'oldest' ? 'oldest first' : 'most recent'}${ticketGroupByTier ? ' · grouped by ticket type' : ''}</p>${sections}</body></html>`;
                         const w = window.open('', '_blank');
                         if (w) { w.document.write(html); w.document.close(); w.focus(); setTimeout(() => w.print(), 300); }
                       };
                       return (
                       <div className="mt-8">
                         <div className="flex items-center justify-between mb-3">
                           <div>
                             <h4 className="font-semibold text-gray-900">Ticket Sales</h4>
                             <p className="text-xs text-gray-500">{ticketBuyers.length} orders · {totalTickets} tickets · you earned <span className="font-semibold text-teal-700">{naira(earnings)}</span></p>
                           </div>
                           <div className="flex flex-wrap items-center gap-2">
                             <select value={ticketSort} onChange={(e) => setTicketSort(e.target.value as any)} className="rounded-lg border border-gray-300 px-2 py-1.5 text-xs text-gray-700">
                               <option value="recent">Most recent</option>
                               <option value="oldest">Order of purchase</option>
                               <option value="alpha">Buyer name (A–Z)</option>
                             </select>
                             <button onClick={() => setTicketGroupByTier(v => !v)} className={`inline-flex items-center gap-1.5 rounded-lg border px-3 py-1.5 text-sm ${ticketGroupByTier ? 'border-teal-400 bg-teal-50 text-teal-700' : 'border-gray-300 text-gray-700 hover:bg-gray-50'}`}>
                               <i className="ri-stack-line"></i> {ticketGroupByTier ? 'Grouped by type' : 'Group by type'}
                             </button>
                             <button onClick={printSales} className="inline-flex items-center gap-1.5 rounded-lg border border-gray-300 px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50">
                               <i className="ri-printer-line"></i> Print list
                             </button>
                           </div>
                         </div>
                         <div className="overflow-x-auto space-y-5">
                           {groups.map((g, gi) => (
                             <div key={gi}>
                               {g.label && (
                                 <div className="mb-1.5 flex items-center gap-2 text-sm font-semibold text-teal-700">
                                   <i className="ri-ticket-2-line"></i> {g.label}
                                   <span className="text-xs font-normal text-gray-400">· {g.rows.length} orders · {g.rows.reduce((s, p) => s + (Number(p.quantity) || 1), 0)} tickets</span>
                                 </div>
                               )}
                               <table className="min-w-full text-sm">
                                 <thead>
                                   <tr className="text-left text-gray-600 bg-gray-50">
                                     <th className="px-2 py-2">Event</th>
                                     <th className="px-2 py-2">Buyer</th>
                                     <th className="px-2 py-2">Email</th>
                                     <th className="px-2 py-2">Phone</th>
                                     <th className="px-2 py-2">Tier</th>
                                     <th className="px-2 py-2">Qty</th>
                                     <th className="px-2 py-2">Amount</th>
                                     <th className="px-2 py-2">Code(s)</th>
                                     <th className="px-2 py-2">Date</th>
                                   </tr>
                                 </thead>
                                 <tbody>
                                   {g.rows.map((p) => { const link = ticketLinks.find(l => l.id === p.linkId); const dateStr = p.createdAt?.toDate ? p.createdAt.toDate().toLocaleString() : ''; const codes = Array.isArray(p.codes) ? p.codes.join(', ') : (p.code || ''); return (
                                     <tr key={p.id} className="border-t border-gray-200">
                                       <td className="px-2 py-2">{link?.title || p.linkId}</td>
                                       <td className="px-2 py-2">{p.buyerName || <span className="text-gray-400">{p.buyerId || '—'}</span>}</td>
                                       <td className="px-2 py-2 text-xs">{p.buyerEmail || '—'}</td>
                                       <td className="px-2 py-2 text-xs">{p.buyerPhone || '—'}</td>
                                       <td className="px-2 py-2 text-xs">{p.tierName || '—'}</td>
                                       <td className="px-2 py-2 text-center">{p.quantity || 1}</td>
                                       <td className="px-2 py-2 font-medium">{naira(p.totalAmount || 0)}</td>
                                       <td className="px-2 py-2 font-mono text-[11px]">{codes}</td>
                                       <td className="px-2 py-2 text-xs">{dateStr}</td>
                                     </tr> ); })}
                                 </tbody>
                               </table>
                             </div>
                           ))}
                         </div>
                       </div>
                       );
                     })()}
                   </div>
                 )}
 
               </div>
             )}

            {/* Listings Tab */}
            {activeTab === 'listings' && (
              <div>
                <div className="flex justify-between items-center mb-6">
                  <h2 className="text-xl font-semibold text-gray-900">My Listings</h2>
                  <div className="flex items-center gap-2">
                    <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" onClick={handlePostNewItem}>
                      <i className="ri-add-line mr-2"></i>
                      New Listing
                    </button>
                    <button className="px-4 py-2 bg-gray-900 text-white rounded-lg hover:bg-black transition-colors" onClick={() => setManageOpen(true)}>
                      <i className="ri-settings-3-line mr-2"></i>
                      Manage
                    </button>
                  </div>
                </div>
                
                {listings.length > 0 ? (
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {listings.map((item) => (
                      <div key={item.id} className="border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
                        <img
                          src={(item.images && item.images[0]) || ''}
                          alt={item.title}
                          className="w-full h-48 object-cover object-top"
                        />
                        <div className="p-4">
                          <div className="flex items-center justify-between mb-2">
                            <h3 className="font-semibold text-gray-900">{item.title}</h3>
                            <span className={`px-2 py-1 rounded-full text-xs font-medium ${item.soldOut ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'}`}>
                              {item.soldOut ? 'sold out' : 'active'}
                            </span>
                          </div>
                          <div className="flex justify-between items-center mb-2">
                            <span className="text-xl font-bold text-blue-600">₦{(item.price ?? 0).toLocaleString()}</span>
                            <span className="text-sm text-gray-500">{item.category || 'Uncategorized'}</span>
                          </div>
                          <div className="space-y-2 mb-3">
                            {item.type === 'ticket' && Array.isArray(item.ticketTiers) && item.ticketTiers.length > 0 && (
                              <div className="border border-gray-200 rounded-lg p-2">
                                <div className="flex justify-between items-center mb-2">
                                  <span className="text-sm font-medium text-gray-700">Ticket Tiers</span>
                                  <div className="flex gap-2">
                                    <button
                                      className="px-2 py-1 text-xs border rounded hover:bg-gray-50"
                                      onClick={() => markAllTiers(item, true)}
                                      disabled={updatingListingId === item.id}
                                    >
                                      Mark all sold out
                                    </button>
                                    <button
                                      className="px-2 py-1 text-xs border rounded hover:bg-gray-50"
                                      onClick={() => markAllTiers(item, false)}
                                      disabled={updatingListingId === item.id}
                                    >
                                      Mark all available
                                    </button>
                                  </div>
                                </div>
                                <div className="space-y-1">
                                  {item.ticketTiers.map((t, idx) => (
                                    <div key={idx} className="flex justify-between items-center">
                                      <span className="text-sm text-gray-700">{t.name} - ₦{t.price?.toLocaleString()}</span>
                                      <button
                                        className={`px-2 py-1 text-xs rounded ${t.soldOut ? 'bg-red-600 text-white' : 'bg-green-600 text-white'}`}
                                        onClick={() => toggleTierSoldOut(item, idx, !t.soldOut)}
                                        disabled={updatingListingId === item.id}
                                      >
                                        {t.soldOut ? 'Mark available' : 'Mark sold out'}
                                      </button>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="flex space-x-2">
                            <button className="flex-1 px-3 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm" onClick={() => navigate(`/listing/${item.id}`)}>
                              View
                            </button>
                            <button className="flex-1 px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm" onClick={() => navigate('/sell')}>
                              Edit
                            </button>
                          </div>
                          <div className="mt-3">
                            <button
                              className="w-full px-3 py-2 text-sm border rounded hover:bg-gray-50"
                              onClick={() => toggleSoldOut(item)}
                              disabled={updatingListingId === item.id}
                            >
                              {item.soldOut ? 'Mark as Available' : 'Mark as Sold Out'}
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-12">
                    <i className="ri-store-line text-6xl text-gray-300 mb-4"></i>
                    <p className="text-gray-500 mb-2">No listings yet</p>
                    <p className="text-gray-400 text-sm mb-6">Create your first listing to start selling</p>
                    <button className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" onClick={() => { setCreateModalType('item'); setShowCreateModal(true); }}>
                      Create First Listing
                    </button>
                  </div>
                )}
              </div>
            )}

            {/* Analytics Tab */}
            {activeTab === 'analytics' && (
              <div>
                <h2 className="text-xl font-semibold text-gray-900 mb-6">Analytics</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="bg-white border border-gray-200 rounded-lg p-6">
                    <h3 className="font-semibold text-gray-900 mb-4">Views Over Time</h3>
                    <div className="h-32 bg-gray-100 rounded">
                      {(() => {
                        const lastNDays = (n: number) => {
                          const days: string[] = [];
                          const today = new Date();
                          for (let i = n - 1; i >= 0; i--) {
                            const d = new Date(today);
                            d.setDate(today.getDate() - i);
                            const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
                            days.push(key);
                          }
                          return days;
                        };
                        const keys = lastNDays(14);
                        const series = dailyViewsSeries.length > 0
                          ? keys.map(k => ({ key: k, value: (dailyViewsSeries.find(s => s.date === k)?.count ?? 0) }))
                          : keys.map(k => ({ key: k, value: 0 }));
                        const maxVal = Math.max(1, ...series.map(p => p.value));
                        const chartWidth = 500;
                        const chartHeight = 120;
                        const padding = 24;
                        const points = series.map((p, i) => {
                          const x = padding + (i * (chartWidth - padding * 2)) / (series.length - 1);
                          const y = padding + (1 - p.value / maxVal) * (chartHeight - padding * 2);
                          return `${x},${y}`;
                        }).join(' ');
                        return (
                          <svg viewBox={`0 0 ${chartWidth} ${chartHeight}`} className="w-full h-full">
                            <polyline fill="none" stroke="rgb(37 99 235)" strokeWidth="2" points={points} />
                            <line x1={padding} y1={chartHeight - padding} x2={chartWidth - padding} y2={chartHeight - padding} stroke="#9ca3af" strokeDasharray="3 3" />
                          </svg>
                        );
                      })()}
                    </div>
                  </div>
                  <div className="bg-white border border-gray-200 rounded-lg p-6">
                    <h3 className="font-semibold text-gray-900 mb-4">Top Performing Items</h3>
                    <div className="space-y-3">
                      {listings.slice(0, 3).map((l) => (
                        <div key={l.id} className="flex justify-between">
                          <span className="text-gray-700">{l.title}</span>
                          <span className="text-gray-900 font-medium">₦{(l.price ?? 0).toLocaleString()}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="bg-white border border-gray-200 rounded-lg p-6">
                    <h3 className="font-semibold text-gray-900 mb-4">Profile Views Over Time</h3>
                    <div className="h-32 bg-gray-100 rounded">
                      {(() => {
                        const lastNDays = (n: number) => {
                          const days: string[] = [];
                          const today = new Date();
                          for (let i = n - 1; i >= 0; i--) {
                            const d = new Date(today);
                            d.setDate(today.getDate() - i);
                            const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
                            days.push(key);
                          }
                          return days;
                        };
                        const keys = lastNDays(14);
                        const series = dailyProfileViewsSeries.length > 0
                          ? keys.map(k => ({ key: k, value: (dailyProfileViewsSeries.find(s => s.date === k)?.count ?? 0) }))
                          : keys.map(k => ({ key: k, value: 0 }));
                        const maxVal = Math.max(1, ...series.map(p => p.value));
                        const chartWidth = 500;
                        const chartHeight = 120;
                        const padding = 24;
                        const points = series.map((p, i) => {
                          const x = padding + (i * (chartWidth - padding * 2)) / (series.length - 1);
                          const y = padding + (1 - p.value / maxVal) * (chartHeight - padding * 2);
                          return `${x},${y}`;
                        }).join(' ');
                        return (
                          <svg viewBox={`0 0 ${chartWidth} ${chartHeight}`} className="w-full h-full">
                            <polyline fill="none" stroke="rgb(16 185 129)" strokeWidth="2" points={points} />
                            <line x1={padding} y1={chartHeight - padding} x2={chartWidth - padding} y2={chartHeight - padding} stroke="#9ca3af" strokeDasharray="3 3" />
                          </svg>
                        );
                      })()}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Settings Tab */}
            {activeTab === 'settings' && (
              <div>
                <h2 className="text-xl font-semibold text-gray-900 mb-6">Account Settings</h2>

                <div className="space-y-6">
                  <div className="bg-white border border-gray-200 rounded-lg p-6">
                    <h3 className="font-semibold text-gray-900 mb-4">Profile Information</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Full Name</label>
                        <input
                          type="text"
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                          value={userName}
                          readOnly
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                        <input
                          type="email"
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                          value={email ?? ''}
                          readOnly
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">University</label>
                        <input
                          type="text"
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                          value={university ?? ''}
                          readOnly
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Phone</label>
                        <input
                          type="text"
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                          value={phone ?? ''}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>

                  <div className="bg-white border border-gray-200 rounded-lg p-6">
                    <h3 className="font-semibold text-gray-900 mb-4">Verification Status</h3>
                    <div className="flex items-center space-x-3">
                      <div className={`w-3 h-3 rounded-full ${isVerified ? 'bg-green-500' : 'bg-yellow-500'}`}></div>
                      <span className="text-gray-700">
                        {isVerified ? 'Student ID Verified' : 'Student ID Pending Review'}
                      </span>
                    </div>
                    {!isVerified && (
                      <button className="mt-3 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" onClick={() => navigate('/sell?step=verification&resume=docs')}>
                        Upload Student ID
                      </button>
                    )}
                  </div>

                  <div className="bg-white border border-gray-200 rounded-lg p-6">
                    <h3 className="font-semibold text-gray-900 mb-4">Subscription</h3>
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-gray-700">Current Plan: <span className="font-medium">—</span></p>
                      </div>
                      <button 
                        onClick={handleUpgrade}
                        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                      >
                        Upgrade
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Wallet Tab */}
            {activeTab === 'wallet' && (
              <div>
                <h2 className="text-xl font-semibold text-gray-900 mb-6">My Wallet</h2>
                <div className="bg-white border border-gray-200 rounded-lg p-6">
                  <h3 className="font-semibold text-gray-900 mb-4">Wallet Balance</h3>
                  <p className="text-3xl font-bold text-green-600">₦{(wallet?.balance ?? 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                  <div className="mt-4 text-sm text-gray-600">Escrow: ₦{(wallet?.escrowBalance ?? 0).toLocaleString()}</div>
                  <button className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" onClick={() => navigate('/wallet')}>
                    Manage Wallet
                  </button>
                </div>
              </div>
            )}
          {/* Single vs Bulk chooser */}
          {/* Mandatory: complete seller profile (store name + school) */}
          {showCompleteProfile && (
            <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 p-4">
              <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
                <div className="mb-3 flex items-center gap-2">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-teal-100 text-teal-600"><i className="ri-store-2-line text-lg"></i></span>
                  <h3 className="text-lg font-semibold text-gray-900">Complete your seller profile</h3>
                </div>
                <p className="mb-4 text-sm text-gray-500">A store name and school are now required for all sellers. Please add them to continue.</p>
                <div className="space-y-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Store / vendor name</label>
                    <input
                      value={cpUsername}
                      onChange={(e) => setCpUsername(e.target.value)}
                      placeholder="e.g. Dave's Gadgets"
                      className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
                    />
                    <p className="mt-1 text-xs text-teal-600">Shown to buyers on the marketplace.</p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">School</label>
                    <input
                      list="cp-universities"
                      value={cpUniversity}
                      onChange={(e) => setCpUniversity(e.target.value)}
                      placeholder="Start typing your school…"
                      className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
                    />
                    <datalist id="cp-universities">
                      {NIGERIAN_UNIVERSITIES.map((u) => <option key={u} value={u} />)}
                    </datalist>
                  </div>
                </div>
                <button
                  onClick={handleCompleteProfile}
                  disabled={cpSaving}
                  className="mt-5 w-full rounded-lg bg-teal-600 py-2.5 text-sm font-semibold text-white hover:bg-teal-700 disabled:opacity-60"
                >
                  {cpSaving ? 'Saving…' : 'Save & Continue'}
                </button>
              </div>
            </div>
          )}
          {showCreateChooser && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={() => setShowCreateChooser(false)}>
              <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl" onClick={(e) => e.stopPropagation()}>
                <div className="mb-4 flex items-center justify-between">
                  <h3 className="text-lg font-semibold text-gray-900">Create Listing</h3>
                  <button onClick={() => setShowCreateChooser(false)} className="text-gray-400 hover:text-gray-600" aria-label="Close">
                    <i className="ri-close-line text-2xl"></i>
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <button
                    onClick={() => { setShowCreateChooser(false); setCreateModalType('item'); setShowCreateModal(true); }}
                    className="flex flex-col items-center gap-2 rounded-xl border border-gray-200 p-5 text-center transition-colors hover:border-blue-400 hover:bg-blue-50/50"
                  >
                    <span className="flex h-12 w-12 items-center justify-center rounded-full bg-blue-100 text-blue-600"><i className="ri-add-circle-line text-2xl"></i></span>
                    <span className="font-semibold text-gray-900">Single Listing</span>
                    <span className="text-xs text-gray-500">Post one item</span>
                  </button>
                  <button
                    onClick={() => { setShowCreateChooser(false); setShowBulkModal(true); }}
                    className="flex flex-col items-center gap-2 rounded-xl border border-gray-200 p-5 text-center transition-colors hover:border-teal-400 hover:bg-teal-50/50"
                  >
                    <span className="flex h-12 w-12 items-center justify-center rounded-full bg-teal-100 text-teal-600"><i className="ri-stack-line text-2xl"></i></span>
                    <span className="font-semibold text-gray-900">Bulk Listing</span>
                    <span className="text-xs text-gray-500">Post many at once</span>
                  </button>
                </div>
              </div>
            </div>
          )}
          {/* Render Create Listing Modal */}
          <CreateListingModal
            isOpen={showCreateModal}
            onClose={() => setShowCreateModal(false)}
            onCreated={(id) => { setCreatedListingId(id); setShowSuccessModal(true); }}
            initialType={createModalType}
          />
          <CreateTicketModal
            isOpen={showTicketModal || !!editingTicket}
            editLink={editingTicket}
            onClose={() => { setShowTicketModal(false); setEditingTicket(null); }}
            onCreated={refreshTicketLinks}
          />
          <BulkListingModal
            isOpen={showBulkModal}
            onClose={() => setShowBulkModal(false)}
            onCreated={async () => {
              try {
                const uid = auth.currentUser?.uid;
                if (uid) setListings((await getSellerListings(uid)).filter(l => l.type !== 'ticket'));
              } catch (e) { console.warn('Failed to refresh listings', e); }
            }}
          />
          <ListingSuccessModal
            isOpen={showSuccessModal}
            onClose={() => setShowSuccessModal(false)}
            listingId={createdListingId}
          />
          <ManageListingsModal
            isOpen={manageOpen}
            onClose={() => setManageOpen(false)}
            listings={listings}
            onChange={async () => {
              try {
                const uid = auth.currentUser?.uid;
                if (!uid) return;
                const data = (await getSellerListings(uid)).filter(l => l.type !== 'ticket');
                setListings(data);
              } catch (e) {
                console.warn('Failed to refresh listings', e);
              }
            }}
          />

          {/* Create Ticket Link Modal */}
          {showCreateTicketLinkModal && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
              <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Create Ticket Link</h3>
                <div className="space-y-3">
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">Title</label>
                    <input className="w-full border border-gray-300 rounded px-3 py-2" value={tlFormTitle} onChange={(e) => setTlFormTitle(e.target.value)} placeholder="e.g., Freshers Night" />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">Price (₦)</label>
                    <input type="number" step="0.01" className="w-full border border-gray-300 rounded px-3 py-2" value={tlFormPrice} onChange={(e) => setTlFormPrice(e.target.value)} placeholder="e.g., 1500" />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">Max quantity (optional)</label>
                    <input type="number" className="w-full border border-gray-300 rounded px-3 py-2" value={tlFormMaxQty} onChange={(e) => setTlFormMaxQty(e.target.value)} placeholder="e.g., 100" />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">Description (optional)</label>
                    <textarea className="w-full border border-gray-300 rounded px-3 py-2" rows={3} value={tlFormDescription} onChange={(e) => setTlFormDescription(e.target.value)} placeholder="Short note for buyers" />
                  </div>
                </div>
                <div className="mt-5 flex items-center justify-end gap-2">
                  <button className="px-3 py-2 border rounded hover:bg-gray-50" onClick={() => setShowCreateTicketLinkModal(false)} disabled={tlSaving}>Cancel</button>
                  <button className="px-3 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-60" onClick={handleCreateTicketLink} disabled={tlSaving}>{tlSaving ? 'Creating…' : 'Create'}</button>
                </div>
              </div>
            </div>
          )}

          {/* Share Ticket Link Modal */}
          {shareTicketLinkModalOpen && createdTicketLinkId && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
              <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Ticket Link Created</h3>
                <p className="text-sm text-gray-600 mb-4">Copy or share your purchase link below.</p>
                <div className="flex gap-2">
                  <input className="flex-1 border border-gray-300 rounded px-3 py-2" readOnly value={purchaseUrlFromId(createdTicketLinkId)} />
                  <button className="px-3 py-2 border rounded hover:bg-gray-50" onClick={() => handleCopyPurchaseUrl(createdTicketLinkId)}>Copy</button>
                </div>
                <div className="mt-3 flex items-center gap-3">
                  <a href={purchaseUrlFromId(createdTicketLinkId)} target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">Open link</a>
                </div>
                <div className="mt-5 flex items-center justify-end">
                  <button className="px-3 py-2 bg-blue-600 text-white rounded hover:bg-blue-700" onClick={() => setShareTicketLinkModalOpen(false)}>Done</button>
                </div>
              </div>
            </div>
          )}

          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default SellerDashboard;
